import {
    ModelSetTransformer,
    ModelTransformer,
} from '../../common/common.model';

import { ModelBase } from './tag.coaching.model';

export interface MetricItem {
    id: number;
    initials: string;
    shortName: string;
    name: string;
    rankOrder?: number;
}

class MetricModelTransformer
    implements ModelTransformer<MetricItem, ModelBase>
{
    transform(model: ModelBase): MetricItem {
        return {
            id: model.id,
            initials: model.text.initials,
            shortName: model.text.shortName,
            name: model.text.name,
            rankOrder: model.rankOrder === true ? 1 : -1, // 1 - higher better, -1 - lower better
        };
    }
}

export class MetricModelSetTransformer extends ModelSetTransformer<
    MetricItem,
    ModelBase
> {
    protected newTransformer(): ModelTransformer<MetricItem, ModelBase> {
        return new MetricModelTransformer();
    }
}
